import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const STUDIO_POSITION = [23.0324105, 72.5077774];
const GOOGLE_MAPS_URL = 'https://maps.app.goo.gl/iRHrhCBrYR8773jA8';

// Custom navy pin (Leaflet's default marker 404s under bundlers)
const studioIcon = L.divIcon({
  className: 'studio-map-pin',
  html: `
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24"
      fill="#002F6C" stroke="#ffffff" stroke-width="1.2"
      style="filter: drop-shadow(0 2px 3px rgba(0,0,0,0.3));">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
      <circle cx="12" cy="9" r="2.6" fill="#ffffff" stroke="none"/>
    </svg>
  `,
  iconSize: [34, 34],
  iconAnchor: [17, 34],
  popupAnchor: [0, -32],
});

export const ContactMap = () => {
  return (
    <div className="contact-map-block" data-testid="contact-map-block">
      {/* Sketch / toner styling applied to TILES ONLY + faint navy duotone wash */}
      <style>{`
        .contact-map { position: relative; height: 100%; width: 100%; }
        .contact-map .leaflet-tile {
          filter: grayscale(1) contrast(1.08) brightness(1.03);
        }
        .contact-map::after {
          content: '';
          position: absolute;
          inset: 0;
          background: #002F6C;
          opacity: 0.07;
          mix-blend-mode: multiply;
          pointer-events: none;
          z-index: 400;
        }
        .contact-map .leaflet-control-attribution {
          font-size: 9px;
          color: #9ca3af;
          background: rgba(255,255,255,0.7);
        }
        .studio-map-pin { background: transparent; border: none; }
      `}</style>

      <div className="aspect-video w-full overflow-hidden" data-testid="contact-map-wrapper">
        <MapContainer
          className="contact-map"
          center={STUDIO_POSITION}
          zoom={16}
          scrollWheelZoom={false}
          style={{ height: '100%', width: '100%' }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={STUDIO_POSITION} icon={studioIcon}>
            <Popup>
              <span
                className="lowercase"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 700, color: '#002F6C' }}
              >
                twoplustwo
              </span>
              <br />
              <span style={{ fontFamily: 'Lato, sans-serif', fontWeight: 300, color: '#4b5563' }}>
                2nd floor, l-block, mondeal retail park
              </span>
            </Popup>
          </Marker>
        </MapContainer>
      </div>

      <a
        href={GOOGLE_MAPS_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="open-google-maps-btn"
        className="mt-4 inline-flex items-center justify-center gap-2 w-full bg-[#002F6C] text-white py-3 hover:bg-[#001f4d] transition-colors lowercase text-sm"
        style={{ fontFamily: 'Inter, sans-serif', fontWeight: 700 }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
        open in google maps
      </a>
    </div>
  );
};

export default ContactMap;
